<template>
  <div>
    <Card>
      <Breadcrumb separator="|">
        <BreadcrumbItem>
          <a
            @click="
              () => {
                this.$router.back();
              }
            "
          >
            <i class="ivu-icon ivu-icon-md-arrow-back" style="font-size: 20px"></i>
            返回
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem>{{ isAdd ? '新增' : '编辑' }}项目</BreadcrumbItem>
      </Breadcrumb>
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <Row style="margin-top: 20px; border-top: 1px solid #f8f8f9">
          <Col :span="8" style="border-right: 1px solid #f8f8f9; padding: 20px 40px 0 0">
            <FormItem label="项目名称：" prop="name">
              <Input v-model="formValidate.name" placeholder="请输入项目名称"></Input>
            </FormItem>
            <FormItem label="帮扶类型：" prop="helpType">
              <Select v-model="formValidate.helpType" placeholder="请选择帮扶类型">
                <Option v-for="item in typeList" :value="item.value">{{ item.label }}</Option>
                <!-- <Option value="职业介绍">职业介绍</Option> -->
              </Select>
            </FormItem>
            <FormItem label="帮扶计划：">{{ planName }}</FormItem>
            <FormItem label="所需积分：">
              {{ formValidate.needScore }}
              <!-- <FormItem label="所需积分：" prop="needScore">
              <Input v-model="formValidate.needScore" placeholder="请输入所需积分"></Input>
            </FormItem> -->
            </FormItem>
            <FormItem label="开始时间：" prop="startTime">
              <DatePicker type="datetime" placeholder="请选择项目开始时间" v-model="formValidate.startTime"></DatePicker>
            </FormItem>
            <FormItem label="结束时间：" prop="endTime">
              <DatePicker type="datetime" placeholder="请选择项目开始时间" v-model="formValidate.endTime"></DatePicker>
            </FormItem>
            <FormItem label="地点：" prop="address">
              <Input v-model="formValidate.address" placeholder="请输入地址"></Input>
            </FormItem>
            <FormItem label="封面：" prop="cover">
              <p style="color: #c5c8ce">图片不超过2MB，推荐尺寸200px*200px</p>
              <!-- <Upload multiple type="drag" action="//jsonplaceholder.typicode.com/posts/">
                <div style="padding: 20px 0">
                  <i class="ivu-icon ivu-icon-md-add" style="font-size: 52px; color: #c5c8ce"></i>
                  <p>上传</p>
                </div>
              </Upload> -->
              <Upload
                :headers="$uploader.headers()"
                :action="$uploader.action"
                :on-success="uploadSuccess1"
                :before-upload="$uploader.beforeUpload"
                :on-format-error="handleFormatError"
                :show-upload-list="false"
                :file-list="[]"
                :format="['png', 'jpg', 'jpeg']"
              >
                <!-- <div style="padding: 20px 0" v-if="!formValidate.cover">
                <i class="ivu-icon ivu-icon-md-add" style="font-size: 52px; color: #c5c8ce"></i></div> -->
                <img v-if="formValidate.cover" :src="formValidate.cover" />
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            <FormItem style="text-align: right">
              <Button @click="handleSubmit(1)">存草稿</Button>
              <Button type="primary" @click="handleSubmit(2)" style="margin-left: 8px">提交审核</Button>
            </FormItem>
          </Col>
          <Col :span="16">
            <FormItem label="文字介绍" prop="content" class="content">
              <editor v-model="formValidate.content"></editor>
              <!-- <Input type="textarea" @input="checkLength"  v-model="formValidate.content" style="width:100%;height: 500px" :maxlength="maxLength"/> -->
              <!-- <div class="counter">
              最多输入{{ formValidate.content.length }} / {{ maxLength }}字
            </div> -->
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
  </div>
</template>
<script>
import editor from '@/components/editor/editor';
export default {
  components: {editor},
  data() {
    return {
      editorInit: {
        height: 500,
        menubar: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
          'undo redo | formatselect | bold italic backcolor | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help'
      },
      isAdd: false,
      planName: '',
      typeList: [
        // {value: 1,label:"职业能力测评"},
        // {value: 2,label:"就业技能培训"},
        // {value: 3,label:"岗位推荐"},
        // {value: 4,label:"面试辅导"},
      ],
      maxLength: 20000, // 最大字数限制
      formValidate: {
        // name: '',
        // mail: '',
        // city: '',
        // gender: '',
        // interest: [],
        // date: '',
        // time: '',
        // desc: '' ,
        content: '',
        planId: 1,
        needScore: 2000,
        status: 1
      },
      ruleValidate: {
        name: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        helpType: [{ required: true, message: '帮扶类型不能为空', trigger: 'change' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        startTime: [{ required: true, type: 'date', message: '开始时间不能为空', trigger: 'change' }],
        endTime: [{ required: true, type: 'date', message: '结束时间不能为空', trigger: 'change' }],
        address: [{ required: false, message: '地点不能为空', trigger: 'blur' }],
        cover: [{ required: true, message: '封面不能为空', trigger: 'change' }],
        content: [{ required: true, message: '文字介绍不能为空', trigger: 'change' }]
      }
    };
  },
  created() {
    this.isAdd = this.$route.query.isAdd;
    console.log(this.isAdd);
    if (this.$route.query.planId) {
      this.formValidate.planId = this.$route.query.planId;
      this.$axios
        .request({
          url: 'front/v1/help-plan/company/' + this.formValidate.planId,
          method: 'get'
        })
        .then(res => {
          this.planName = res.data.name;
          this.formValidate.needScore = res.data.projectScore;
          this.getAddress();
          // this.formValidate.address = res.data.address;
        });
    } else if (this.$route.query.id) {
      const id = this.$route.query.id;
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-project/detail/' + id,
          method: 'get'
        })
        .then(res => {
          // this.helpPlanDetail = res.data;
          (this.formValidate.name = res.data.name), (this.formValidate.planId = res.data.plan.id);
          this.planName = res.data.plan.name;
          this.formValidate.helpType = res.data.helpType;
          this.formValidate.needScore = res.data.needScore;
          // this.formValidate.cover = res.data.cover
          this.$set(this.formValidate, 'cover', res.data.cover);
          this.formValidate.startTime = res.data.startTime;
          this.formValidate.endTime = res.data.endTime;
          this.formValidate.address = res.data.address;
          // this.formValidate.content = res.data.content
          this.$set(this.formValidate, 'content', res.data.content);

          this.formValidate.id = res.data.id;
        });
    }
    this.getType();
  },
  mounted() {},
  // computed: {
  //   remainingChars() {
  //     return this.maxLength - this.formValidate.content.length; // 剩余字数计算
  //   },
  // },
  methods: {
    onEditorInit(editor) {
      // 编辑器初始化完成后的回调
      console.log('TinyMCE is ready!', editor);
    },
    // handleSubmit(name) {
    //   this.$refs[name].validate(valid => {
    //     console.log(this.formValidate);
    //     if (valid) {
    //       this.$Message.success('Success!');
    //     } else {
    //       this.$Message.error('Fail!');
    //     }
    //   });
    // },
    getType() {
      this.$axios
        .request({
          url: 'front/v1/help/config',
          method: 'get'
        })
        .then(res => {
          this.typeList = res.data.helpType;
        });
    },
    checkLength() {
      if (this.formValidate.content.length >= this.maxLength) {
        this.$Message.error('超出最大字数');
        this.formValidate.content = this.formValidate.content.slice(0, this.maxLength); // 限制输入长度
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不对',
        desc: '需上传jpg, png, jpeg格式文件'
      });
    },
    getAddress() {
      this.$axios
        .request({
          url: 'front/v1/company/myCompany',
          method: 'get'
        })
        .then(res => {
          // this.planName = res.data.name
          // this.formValidate.address = res.data.address;
          this.$set(this.formValidate, 'address', res.data.address);
        });
    },
    uploadSuccess1(res) {
      // this.$set(this.form, 'entryCerificate', []);
      // this.formValidate.cover =  res.data.url
      this.$set(this.formValidate, 'cover', res.data.url);

      // this.form.entryCerificate.push({
      //   url: res.data.url,
      //   name: res.data.name
      // });
    },
    handleSubmit(status) {
      // this.$refs['formValidate'].resetFields();
      // console.log(this.$refs["formValidate"])
      this.formValidate.status = status;
      this.formValidate.planId = parseInt(this.formValidate.planId);
      this.$refs['formValidate'].validate(valid => {
        if (valid) {
          if (this.formValidate.id) {
            this.$axios
              .request({
                url: 'front/v1/company/help-plan-project/' + this.formValidate.id,
                method: 'put',
                data: this.formValidate
              })
              .then(res => {
                if (res.code == 200) {
                  this.$Message.success(res.msg);
                  // this.$router.push({ name: 'HelpPlan', query: { subMenuCurrentName:"1" } });
                  this.$router.go(-1);
                }
              });
          } else {
            this.$axios
              .request({
                url: 'front/v1/company/help-plan-project',
                method: 'post',
                data: this.formValidate
              })
              .then(res => {
                if (res.code == 200) {
                  this.$Message.success(res.msg);
                  this.$router.go(-1);
                  // this.$router.push({ name: 'HelpPlan', query: { subMenuCurrentName:"1" } });
                }
              });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  position: relative;
  .counter {
    position: absolute;
    right: 10px;
    bottom: 0;
    color: #999999;
  }
  ::v-deep .ivu-form-item-content {
    margin-left: 0px !important;
    padding: 20px 0 0 50px;
    padding-top: 20px;
    border-top: 1px solid rgb(248, 248, 249);
  }

  ::v-deep .ivu-form-item-label {
    padding: 20px 0;
  }
}
::v-deep textarea.ivu-input {
  height: 500px;
  resize: none;
}
::v-deep .ivu-form-item-label {
  font-weight: bold;
  font-size: 14px;
}
::v-deep .edui-editor-iframeholder {
  min-height: 360px !important;
}
</style>
